import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'
import { BackendAuthProvider } from './components/auth/BackendAuthProvider.jsx'
import './i18n'
import './index.css'

// All authentication now handled by backend
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BackendAuthProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </BackendAuthProvider>
  </React.StrictMode>
)